import { ModalForm, ProFormSelect } from '@ant-design/pro-components';
import PropTypes from 'prop-types';

const normalizeAlias = (value) => (typeof value === 'string' ? value.trim() : '');
const normalizeAliasIdentity = (value) => normalizeAlias(value).replace(/[\s\uFFFC]+/gu, '');
const normalizeAliasSearchText = (value) => normalizeAliasIdentity(value).toLocaleLowerCase();

const normalizeAliases = (aliases) => {
  const aliasesByIdentity = new Map();
  for (const alias of (Array.isArray(aliases) ? aliases : []).map(normalizeAlias).filter(Boolean)) {
    const identity = normalizeAliasIdentity(alias);
    if (!aliasesByIdentity.has(identity)) {
      aliasesByIdentity.set(identity, alias);
    }
  }
  return [...aliasesByIdentity.values()];
};

const StoreAliasesForm = ({ candidateOptions, onFinish, record, trigger }) => (
  <ModalForm
    title="维护门店别名"
    trigger={trigger}
    initialValues={{ aliases: normalizeAliases(record.aliases) }}
    modalProps={{ destroyOnHidden: true }}
    onFinish={(values) => onFinish({ ...values, aliases: normalizeAliases(values.aliases) })}
  >
    <ProFormSelect
      name="aliases"
      label="门店别名"
      fieldProps={{
        fieldNames: {
          label: 'name',
          value: 'name',
        },
        filterOption: (inputValue, option) =>
          normalizeAliasSearchText(option?.name ?? option?.label ?? option?.value).includes(
            normalizeAliasSearchText(inputValue),
          ),
        mode: 'tags',
        options: candidateOptions,
        showSearch: true,
        tokenSeparators: [',', '，'],
      }}
      rules={[{ type: 'array' }]}
      extra={`标准名称：${record.name}`}
    />
  </ModalForm>
);

StoreAliasesForm.propTypes = {
  candidateOptions: PropTypes.arrayOf(
    PropTypes.shape({
      domains: PropTypes.arrayOf(PropTypes.string).isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  onFinish: PropTypes.func.isRequired,
  record: PropTypes.shape({
    aliases: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string.isRequired,
  }).isRequired,
  trigger: PropTypes.node.isRequired,
};

StoreAliasesForm.defaultProps = {
  candidateOptions: [],
};

export default StoreAliasesForm;
